export default __webpack_public_path__ + "e21224eb684dfa21443683a3fc963a3b.ttf";